import { useCallback } from "react";
import { useI18n } from "@lookiero/i18n-react";
import { CURRENCY } from "@lookiero/sty-psp-locale";
import { DOMAIN } from "../i18n/i18n";
import { useStaticInfo } from "./useStaticInfo";

interface FormatCurrencyFunctionArgs {
  readonly amount: number;
}

interface FormatCurrencyFunction {
  (args: FormatCurrencyFunctionArgs): string;
}

interface UseI18nNumberFunction {
  (): FormatCurrencyFunction;
}

const useFormatCurrency: UseI18nNumberFunction = () => {
  const { formatNumber } = useI18n({ domain: DOMAIN });
  const {
    session: {
      user: { country: countryCode },
    },
  } = useStaticInfo();

  const formatCurrency: FormatCurrencyFunction = useCallback(
    ({ amount }) => formatNumber(amount, { style: "currency", currency: CURRENCY[countryCode] }),
    [countryCode, formatNumber],
  );

  return formatCurrency;
};

export { useFormatCurrency };
